import { useEffect, useState } from "react";

//components
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { ProgressSpinner } from "primereact/progressspinner";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from "primereact/dialog";        
import { InputTextarea } from "primereact/inputtextarea";
import ReactMarkdown from 'react-markdown'; 

//api
import { ProjectManagementService } from "../../service/projectmanagement-service"
import { TemplateService } from "../../service/template-service"
import { KBService } from "../../service/kb-service";
import { ElaborationService } from "../../service/elaboration-service";


const NewElaboration = ()=>{
    const [projectData, setProjectData] = useState({
        count: 0,
        next: null,
        previous: null,
        results: [],
    });
    const [selectedProject, setSelectedProject] = useState(null);
    const [templateData, setTemplateData] = useState({
        count: 0,
        next: null,
        previous: null,
        results: [],
      });
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [analysisFiles, setAnalysisFiles] = useState(null) 
    const [kbFiles, setKbFiles]= useState([]);
    const [selectedKBFiles, setSelectedKBFiles] = useState([]);
    const [selectedAnalysisFiles, setSelectedAnalysisFiles] = useState([]);
    const [project, setProject] = useState(null)
    const [customUserPromptContent, setCustomUserPromptContent] = useState('');
    const [customSystemPromptContent, setCustomSystemPromptContent] = useState('');

    const [dialogVisible, setDialogVisible] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    const [dialogHeader, setDialogHeader] = useState('');
    const [previewVisible, setPreviewVisible] = useState(false);
    const [markdownContent, setMarkdownContent] = useState('');
    const [selectedFileForPreview, setSelectedFileForPreview] = useState(null);

    //chiamata GET per recuperare i progetti
    useEffect(()=>{
        const fetchProjects = ()=>{
            ProjectManagementService.getAllProjects(
                (data)=>{
                    if(data && Array.isArray(data.results)){
                        setProjectData(data)

                    }else{
                        const errorMessage = 'La risposta non contiene un array valido di prompt.';
                        console.error(errorMessage);
                    }
                },
                (error) => {
                console.error('Errore durante il recupero dei progetti: ', error);
                }
            )
        }
        fetchProjects();
    },[])

    //chiamata GET per recuperare i template
    useEffect(()=>{
        const fetchTemplates = ()=>{
            TemplateService.getAllTemplates(
                (data)=>{
                    if(data && Array.isArray(data.results)){
                        setTemplateData(data)
                    }else{
                        const errorMessage = 'La risposta non contiene un array valido di prompt.';
                        console.error(errorMessage);
                    }
                },
                (error) => {
                console.error('Errore durante il recupero dei template: ', error);
                }
            )
        }
        fetchTemplates();
    },[])

    const projects = projectData.results.filter(
        (project) => project.id
    );
    const templates = templateData.results.filter(
        (template) => template.id
    );

    //   *************************************************

    //chiamata GET dei file per progetto
    useEffect(() => {
        const fetchProjectFiles = () => {
            if (selectedProject && selectedProject.id) {
                ProjectManagementService.getProjectFiles(
                    selectedProject.id, 
                    (data) => {
                        if (data && Array.isArray(data.results.items)) {
                            setAnalysisFiles(data.results.items);
                        } else if (Array.isArray(data)) {   
                             setAnalysisFiles(data);
                        }
                        else {
                            console.error("API returned unexpected data structure for project files:", data);
                            setAnalysisFiles([]);
                        }   
                    },
                    (error) => {
                        console.error('Errore durante il recupero dei file del progetto: ', error);
                        setAnalysisFiles([]);    
                    }
                );
            } else {
                setAnalysisFiles(null);
            }
        };

        fetchProjectFiles();
    }, [selectedProject]);

    const onAnalysisCheckboxChange = (file) => {
        let _selectedAnalysisFiles = [...selectedAnalysisFiles];
        const index = _selectedAnalysisFiles.findIndex(f => f.id === file.id); 

        if (index > -1) {
            _selectedAnalysisFiles.splice(index, 1);
        } else {
            _selectedAnalysisFiles.push(file);
        }
        setSelectedAnalysisFiles(_selectedAnalysisFiles);
    };

    //anteprima file pdf e md 
    const handlePreview = (file) => {
        if (!file || !file.file_url) {
            console.log('File non valido o URL del file non trovato per l\'anteprima:', file);
            return;
        }

        if (file.file_type === 'pdf') {
            const downloadUrl = file.file_url;
            const fileName = file.name || 'download';
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            console.log('Avviato download per PDF:', fileName);
        } else if (file.file_type === 'md') {
            const downloadUrl = file.file_url;
            const token = localStorage.getItem('token'); 
            if (!token) {
                console.error('Token di autenticazione non trovato. Impossibile scaricare il file Markdown.');
                setDialogHeader('Errore Anteprima');
                setDialogMessage('Token di autenticazione non trovato. Impossibile scaricare il file Markdown.');
                setDialogVisible(true);
                return;
            }

            ProjectManagementService.fetchMarkdownContent(
                downloadUrl,
                token,
                (content) => {
                    setMarkdownContent(content);
                    setSelectedFileForPreview(file);
                    setPreviewVisible(true);
                    console.log('Contenuto Markdown caricato per anteprima:', file.name);
                },
                (error) => {
                    console.error('Errore durante il recupero del contenuto Markdown: ', error);
                    setDialogHeader('Errore Anteprima');
                    setDialogMessage('Impossibile caricare il contenuto del file Markdown.');
                    setDialogVisible(true);
                }
            );
        } else {
            console.log('Anteprima non disponibile per questo tipo di file:', file.file_type);
            setDialogHeader('Anteprima Non Disponibile');
            setDialogMessage(`Anteprima non disponibile per file di tipo: ${file.file_type}.`);
            setDialogVisible(true);
        }
    };

    const hidePreviewDialog = () => {
        setPreviewVisible(false);
        setMarkdownContent('');
        setSelectedFileForPreview(null);
    };

    //   *************************************************

    useEffect(()=>{
        const fetchKB = ()=>{
            KBService.getAllKBFiles(
                (data)=>{
                    if (data && Array.isArray(data.results)) {
                        setKbFiles(data.results); 
                    }else{
                        const errorMessage = "La risposta non contiene un array valido di file.";
                        console.error(errorMessage);
                    }
                },
                (error)=>{
                    console.error('Errore durante il recupero dei file: ', error);
                }
            );
        };
        fetchKB();
    },[])

    const onKBCheckboxChange = (file) => {
        let _selectedKBFiles = [...selectedKBFiles];
        const index = _selectedKBFiles.findIndex(f => f.id === file.id); 

        if (index > -1) {
            _selectedKBFiles.splice(index, 1);
        } else {
            _selectedKBFiles.push(file);
        }
        setSelectedKBFiles(_selectedKBFiles);
    };

    //   *************************************************

    useEffect(()=> {
        const fetchProject=()=>{
            if(selectedProject && selectedProject.id){
                ProjectManagementService.getProject(selectedProject.id,(data)=>{
                    setProject(data)

                    if(data?.user_prompt_details?.content){
                        setCustomUserPromptContent(data.user_prompt_details.content);
                    } else {
                        setCustomUserPromptContent('')
                    }

                    if(data?.system_prompt_details?.content){
                        setCustomSystemPromptContent(data.system_prompt_details.content)
                    } else {
                        setCustomSystemPromptContent('')
                    }
                },
                (error) => {
                    console.error("Errore durante il recupero del progetto:", error);
                    setProject(null);
                    setCustomUserPromptContent('');
                    setCustomSystemPromptContent('');
                })  
            }
        }
        fetchProject()
    },[selectedProject])

    //   *************************************************

    //creazione elaborazione
    const handleCreateElaboration = ()=>{
        if (!selectedProject) {
            setDialogHeader('Errore');
            setDialogMessage("Per favore, seleziona un Progetto.");
            setDialogVisible(true);
            return;
        }
        if (!selectedTemplate) {
            setDialogHeader('Errore');
            setDialogMessage("Per favore, seleziona un Template.");
            setDialogVisible(true);
            return;
        }

        const body = {
            project_id: selectedProject.id,
            template_id: selectedTemplate.id,
            selected_knowledge_base_item_ids: selectedKBFiles.map(file => file.id),
            selected_analysis_document_ids:selectedAnalysisFiles.map(file => file.id),
            custom_system_prompt: customSystemPromptContent,
            custom_user_prompt: customUserPromptContent,
        }

        ElaborationService.createElaboration(
            body,
            (response)=>{
                setDialogHeader('Successo');
                setDialogMessage('Elaborazione creata con successo!');
                setDialogVisible(true);
            },
            (error)=>{
                console.error("Errore durante la creazione dell'elaborazione:", error);
                setDialogHeader('Errore');
                setDialogMessage("Errore durante la creazione dell'elaborazione: " + (error.message || 'Errore sconosciuto'));
                setDialogVisible(true);
            }
        )
    }

    return (
        <div style={{margin:'0 2rem '}}>
            <h2>Crea Elaborazione</h2>
            <Accordion multiple activeIndex={[0]}>
                <AccordionTab header="Scegli un Progetto e un Template">
                    <div>
                        <div className="addProject__Dropdown">
                            <label>Progetto*</label>
                            <Dropdown
                                value={selectedProject}
                                onChange={(e) => setSelectedProject(e.value)}
                                options={projects}
                                optionLabel="name"
                                placeholder="Seleziona un Progetto"
                                className="w-full md:w-14rem"
                                required
                            />
                        </div>
                        <div className="addProject__Dropdown">
                            <label>Template*</label>
                            <Dropdown
                                value={selectedTemplate}
                                onChange={(e) => setSelectedTemplate(e.value)}
                                options={templates}
                                optionLabel="name"
                                placeholder="Seleziona un Template"
                                className="w-full md:w-14rem"
                                required
                            />
                        </div>
                    </div>
                </AccordionTab>
                <AccordionTab header="Visualizza e Scegli i File di Analisi">
                  {!selectedProject ? (
                      <p>Seleziona un progetto per visualizzare i suoi file di analisi.</p>
                  ) : analysisFiles === null ? (
                      <div style={{display: 'flex', justifyContent: 'center', padding: '20px'}}>
                          <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                      </div>
                  ) : analysisFiles.length === 0 ? (
                      <p>Nessun file di analisi trovato per il progetto selezionato.</p>
                  ) : (
                    <div className="p-field-checkbox"> 
                        {analysisFiles.map((file)=>(
                            <div key={file.id} className="p-field-checkbox" style={{ marginBottom: '10px' }}> 
                            <Checkbox 
                                inputId={`file_${file.id}`} 
                                name="analysisFile" 
                                value={file} 
                                onChange={() => onAnalysisCheckboxChange(file)} 
                                checked={selectedAnalysisFiles.some(f => f.id === file.id)} 
                            />
                            <label htmlFor={`file_${file.id}`} style={{ marginLeft: '8px', cursor: 'pointer' }} onClick={(e) => { 
                                handlePreview(file);
                            }}>{file.name}</label>
                            </div>
                        ))}
                    </div>
                  )}
                </AccordionTab>
                <AccordionTab header="Scegli i File di Knowledge Base">
                    {
                        kbFiles ? 
                        kbFiles.map((file)=>(
                             <div key={file.id} className="p-field-checkbox" style={{ marginBottom: '10px' }}> 
                                <Checkbox 
                                    inputId={`file_${file.id}`} 
                                    name="kbFile" 
                                    value={file} 
                                    onChange={() => onKBCheckboxChange(file)} 
                                    checked={selectedKBFiles.some(f => f.id === file.id)} 
                                />
                                <label htmlFor={`file_${file.id}`} style={{ marginLeft: '8px', cursor: 'pointer' }}>{file.title}</label>
                            </div>
                        )):null
                    }
                </AccordionTab>
                <AccordionTab header="Visualizza o Modifica i Prompt">
                    {
                        selectedProject ? (
                            <div>
                                <div className="elaborationDetail__PromptWrapper">
                                    <label>Nome prompt di default: {project?.user_prompt_details.name}</label>
                                    <InputTextarea
                                        value={customUserPromptContent}
                                        onChange={(e) => setCustomUserPromptContent(e.target.value)}
                                        rows={5}
                                        cols={20}
                                    />
                                </div>
                                <div className="elaborationDetail__PromptWrapper">
                                    <label>Nome prompt di sistema: {project?.system_prompt_details.name}</label>
                                    <InputTextarea
                                        value={customSystemPromptContent} 
                                        onChange={(e) => setCustomSystemPromptContent(e.target.value)} 
                                        rows={5}
                                        cols={20}
                                    />
                                </div>
                            </div> 
                        ) : <p>Seleziona un progetto per visualizzare i suoi prompt.</p>
                    }
                   
                </AccordionTab>
            </Accordion>
           <Button label="Crea Elaborazione" type="button" onClick={handleCreateElaboration} style={{margin: '1rem 0', width:'fit-content'}}/>
           <Dialog header={dialogHeader} visible={dialogVisible} style={{ width: '50vw' }} modal onHide={() => setDialogVisible(false)}>
                <p>{dialogMessage}</p>
           </Dialog>
           {selectedFileForPreview && (
                <Dialog
                    header={`Anteprima: ${selectedFileForPreview.name || selectedFileForPreview.title || 'File'}`}
                    visible={previewVisible}
                    style={{ width: '80vw', height: '80vh' }}
                    onHide={hidePreviewDialog}
                    maximizable
                >
                    {selectedFileForPreview.file_type === 'md' ? (
                        <div
                            style={{
                                height: '100%',
                                overflowY: 'auto',
                                border: '1px solid #ccc',
                                padding: '10px',
                                backgroundColor: '#f9f9f9',
                            }}
                        >
                            <ReactMarkdown>{markdownContent}</ReactMarkdown>
                        </div>
                    ) : (
                        <p>
                            Anteprima non disponibile per questo tipo di file (<b>{selectedFileForPreview.file_type}</b>).
                            Il file verrà scaricato se l'URL è valido. Controlla nella cartella Download.
                        </p>
                    )}
                </Dialog>
            )}
        </div>
  );
}

export default NewElaboration